import Vue from 'vue'
import VueRouter from 'vue-router'
import VueYoutube from 'vue-youtube'
Vue.use(VueYoutube)
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/forms',
    name: 'forms',
    component: () => import('../views/Forms.vue')
  },

  {
    path: '/interface',
    name: 'interface',
    component: () => import('../views/Interface.vue')
  },

  {
    path: '/graphs',
    name: 'graphs',
    component: () => import('../views/Graph.vue')
  },


  {
    path: '/quotegenerator',
    name: 'quotegenerator',
    component: () => import('../views/QuoteGenerator.vue')
  },

  {
    path: '/quotes',
    name: 'quotes',
    component: () => import('../views/Quotes.vue')
  },

  {
    path: '/dailybriefing',
    name: 'dailybriefing',
    component: () => import('../views/DailyBriefing.vue')
  },

  {
    path: '/decisiontracker',
    name: 'decisiontracker',
    component: () => import('../views/DecisionTracker.vue')
  },


  {
    path: '/widgets',
    name: 'widgets',
    component: () => import('../views/Widgets.vue')
  },

  {
    path: '/departments',
    name: 'departments',
    component: () => import('../views/Departments.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Register.vue')
  },

  {
    path: '/flowchartbuilder',
    name: 'flowchartbuilder',
    component: () => import('../views/FlowchartBuilder.vue')
  },

  {
    path: '/training',
    name: 'training',
    component: () => import('../views/Training.vue')
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('../views/Projects.vue')
  },

  {
    path: '/dailyagenda',
    name: 'dailyagenda',
    component: () => import('../views/DailyAgenda.vue')
  },
  {
    path: '/sales',
    name: 'sales',
    component: () => import('../views/Sales.vue')
  },
  {
    path: '/marketing',
    name: 'marketing',
    component: () => import('../views/Marketing.vue')
  },
  {
    path: '/accounting',
    name: 'accounting',
    component: () => import('../views/Accounting.vue')
  },
  {
    path: '/hr',
    name: 'hr',
    component: () => import('../views/HR.vue')
  },
  {
    path: '/infrastucture',
    name: 'infrastucture',
    component: () => import('../views/Infrastructure.vue')
  },
  {
    path: '/financials',
    name: 'financials',
    component: () => import('../views/Financials.vue')
  },
  {
    path: '/inventory',
    name: 'inventory',
    component: () => import('../views/Inventory.vue')
  },
  {
    path: '/invoices',
    name: 'invoices',
    component: () => import('../views/Invoices.vue')
  },
  {
    path: '/brand',
    name: 'brand',
    component: () => import('../views/Brand.vue')
  },
  {
    path: '/appointments',
    name: 'appointments',
    component: () => import('../views/Appointments.vue')
  },
  {
    path: '/info',
    name: 'info',
    component: () => import('../views/Info.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/sentimental-analysis',
    name: 'sentimental-analysis',
    component: () => import('../views/SentimentalAnalysis.vue')
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/Help.vue')
  }, {
    path: '/map',
    name: 'map',
    component: () => import('../views/Map.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')

  },
  {
    path: '/accounting',
    name: 'accounting',
    component: () => import('../views/Accounting.vue')

  },
  {
    path: "**",
    name: "home",
    component: Home
  }]

const router = new VueRouter({
  routes
})

export default router
